import { Button, Modal } from '@/components';
import warningPopupImg from '../assets/leads/warningPopup.png';
import stopPopupIcon from '../assets/leads/stopPopup.png';

/**
 * Branded stop confirmation modal (follow-ups, campaigns, etc.).
 */
export function StopFollowUpConfirmModal({
  isOpen,
  onCancel,
  onConfirm,
  isPending = false,
  title = 'Stop Follow-up',
  entityLabel = 'Follow-up',
  description = 'This action cannot be undone and it will not execute anymore.',
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      showClose={false}
      size="sm"
      panelClassName="p-5 sm:p-6 rounded-[24px]"
      zIndexClass="z-[110]"
    >
      {/* Header inside padded panel so divider line matches inset margins */}
      <div className="flex items-center justify-between pb-3 border-b border-[#F0F0F0] mb-4 -mx-5 sm:-mx-6 px-5 sm:px-6">
        <h2 className="text-[20px] font-medium text-[#1F2241]">{title}</h2>
        <button
          type="button"
          onClick={onCancel}
          disabled={isPending}
          className="w-8 h-8 rounded-[8px] bg-[#50AB3D] text-white flex items-center justify-center hover:opacity-90 transition-opacity focus:outline-none shrink-0 disabled:opacity-50"
          aria-label="Close"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      {/* Modal content body */}
      <div className="flex flex-col items-center text-center">
        <img
          src={warningPopupImg}
          alt="Warning"
          className="w-[160px] h-[160px] object-contain mb-3"
          loading="eager"
        />

        <h3 className="text-[20px] font-medium text-[#1F2241] leading-snug">
          Are you sure you want to stop
          <br />
          <span className="text-[#50AB3D]">{entityLabel}</span>?
        </h3>

        <p className="text-[14px] text-[#868686] mt-2 max-w-[280px] leading-normal font-normal">
          {description}
        </p>

        <Button
          variant="danger"
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (!isPending) onConfirm();
          }}
          disabled={isPending}
          className="h-11 px-6 mt-5 rounded-[12px] font-semibold text-sm flex items-center justify-center gap-2"
        >
          <span
            className="w-4 h-4 shrink-0 bg-white inline-block"
            style={{
              maskImage: `url(${stopPopupIcon})`,
              WebkitMaskImage: `url(${stopPopupIcon})`,
              maskSize: 'contain',
              WebkitMaskSize: 'contain',
              maskRepeat: 'no-repeat',
              WebkitMaskRepeat: 'no-repeat',
              maskPosition: 'center',
              WebkitMaskPosition: 'center',
            }}
          />
          <span>{isPending ? 'Stopping...' : 'Stop'}</span>
        </Button>
      </div>
    </Modal>
  );
}
